import { getUserToken, isUserConnected } from "../service/authorization"
import axios from "axios"

export const apigateway = (tunnelData, supplier) => {
  let instance = axios.create({
    baseURL: tunnelData.apiUrl
  })
  instance.interceptors.request.use(
    (config) => {
      if (isUserConnected()) {
        config.headers["Authorization"] = "Bearer " + getUserToken()
      } else {
        if(tunnelData.access_token && tunnelData.isMultitenant){
          config.headers["Authorization"] = "Bearer "+tunnelData.access_token
        }else{
          config.headers["Authorization"] = "Basic cGRpX2FwcDpwZGlQYXNzd29yZA=="
        }
      }
      if (tunnelData.clientIpAddressHeader) {
        config.headers["X-CLIENT-IP"] = tunnelData.clientIpAddressHeader
      }
      if (supplier) {
        config.headers["X-Evollis-Force-Supplier-Id"] = supplier
      }
      return config
    },
    (error) => Promise.reject(error)
  )
  return instance
}

// function to use when you need an API call during the "classic" digital journey where
// the tunnelData.access_token is the single source of truth
export const digitalJourneyApigateway = (tunnelData, supplier) => {
  let instance = axios.create({
    baseURL: tunnelData.apiUrl
  })
  instance.interceptors.request.use(
    (config) => {
      if (isUserConnected()) {
        config.headers["Authorization"] = "Bearer " + getUserToken()
      } else {
        config.headers["Authorization"] = "Bearer " + tunnelData.access_token
        config.headers["Accept"] = "*/*"
      }
      if (tunnelData.clientIpAddressHeader) {
        config.headers["X-CLIENT-IP"] = tunnelData.clientIpAddressHeader
      }
      if (supplier) {
        config.headers["X-Evollis-Force-Supplier-Id"] = supplier
      }
      return config
    },
    (error) => Promise.reject(error)
  )
  return instance
}

export function noAuthApigateway(apiUrl) {
  return axios.create({
    baseURL: apiUrl
  })
}
